var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"position-fixed",style:({bottom: '50px',right: '0', zIndex: '5'})},[_vm._m(0)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-light"},[_c('div',{attrs:{"id":"google_translate_element"}})])
}]

export { render, staticRenderFns }